import React, { useState, useEffect } from "react";
import { FaCreditCard, FaSpinner, FaCheckCircle, FaTimes, FaRupeeSign } from "react-icons/fa";
import { load as loadCashfree } from "@cashfreepayments/cashfree-js";
import "./paynow.css"
const Paynow = ({ planName, planPrice, userPhone, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    
    // Convert price to number (remove ₹ and convert to number)
    const getPriceValue = (price) => {
      if (price === "Free" || price === "Custom") return 1;
      return parseInt(price.replace(/[₹,]/g, '')) || 1;
    };
    
    // Check if this is a customized plan
    const isCustomizedPlan = planName.toLowerCase().includes('customized') || planName.toLowerCase().includes('custom');
    
    // Set initial amount - 1 for customized plans, otherwise use plan price
    const getInitialAmount = () => {
      if (isCustomizedPlan) return 1;
      return getPriceValue(planPrice);
    };
    
    const [paymentData, setPaymentData] = useState({
      amount: getInitialAmount(),
      email: "mail.trillionstockresearch@gmail.com",
      phone: userPhone || "8349500903"
    });

    // Update phone number when userPhone prop changes
    useEffect(() => {
      if (userPhone) {
        setPaymentData(prev => ({
          ...prev,
          phone: userPhone
        }));
      }
    }, [userPhone]);

    // Handle amount change for customized plans
    const handleAmountChange = (e) => {
      const inputValue = e.target.value;
      
      // Remove any non-numeric characters
      const numericValue = inputValue.replace(/[^0-9]/g, '');
      
      // Only update if the cleaned value matches the input (prevents invalid characters)
      if (numericValue === inputValue || inputValue === '') {
        const value = inputValue === '' ? '' : parseInt(numericValue) || 0;
        
        setPaymentData(prev => ({ ...prev, amount: value }));
        
        if (value !== '') {
          if (value < 1) {
            setError("Minimum amount for customized plan is ₹1");
          } else if (value > 200000) {
            setError("Maximum amount for customized plan is ₹2,00,000");
          } else {
            setError(null);
          }
        } else {
          setError(null);
        }
      }
    };

    // Check if payment button should be disabled
    const isPaymentDisabled = () => {
      if (isCustomizedPlan) {
        return paymentData.amount === '' || paymentData.amount < 1 || paymentData.amount > 200000 || loading;
      }
      return loading;
    };
  
  
    const handlePayment = async () => {
      setLoading(true);
      setError(null);
      setSuccess(false);
  
      try {
        // 1. Create order via backend
        const resp = await fetch("https://tstock.trillionstechsolutions.com/payment/create-order", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData)
        });
  
        if (!resp.ok) {
          const text = await resp.text();
          throw new Error(`Backend error: ${resp.status} - ${text}`);
        }
  
        const data = await resp.json();
        const sessionId = data.payment_session_id || data.session_id;
        if (!sessionId) throw new Error("No payment session ID in response");
  
        // 2. Load Cashfree JS SDK
        const cashfree = await loadCashfree({ mode: "production" }); // use "sandbox" for testing :contentReference[oaicite:1]{index=1}
  
        // 3. Trigger checkout
        const result = await cashfree.checkout({
          paymentSessionId: sessionId,
          redirectTarget: "_self"
        });
  
        if (result.error) {
          throw new Error(result.error.message);
        } else if (result.redirect) {
          setSuccess(true);
        }
      } catch (err) {
        console.error("Payment error:", err);
        setError(err.message || "Payment failed. Please try again.");
      } finally {
        setLoading(false);
      }
    };
  
  
    return (
      <div className="payment-container">
        <div className="payment-card">
          <button className="close-payment-btn" onClick={onClose}>
            <FaTimes />
          </button>
          
          <div className="payment-header">
            <div className="payment-icon">
              <FaCreditCard />
            </div>
            <h1>Payment for {planName}</h1>
            <p>Complete your payment securely using Cashfree</p>
            <div className="amount-display">
              <span className="amount-label">Total Amount</span>
              <span className="amount-value">₹{paymentData.amount === '' ? '0' : paymentData.amount}</span>
            </div>
          </div>
  
          <div className="payment-content">
            <h3>Payment Details</h3>
            
            <div className="form-group">
              <label htmlFor="amount">
                <FaRupeeSign className="input-icon" />
                Plan Amount (₹) - {isCustomizedPlan ? 'Editable' : 'Fixed'}
              </label>
              <input 
                type="number" 
                id="amount" 
                name="amount" 
                value={paymentData.amount}
                min={isCustomizedPlan ? "1" : "1"} 
                max={isCustomizedPlan ? "200000" : undefined}
                placeholder={isCustomizedPlan ? "Enter amount (₹1 - ₹2,00,000)" : "Enter amount"} 
                disabled={!isCustomizedPlan}
                onChange={isCustomizedPlan ? handleAmountChange : undefined}
              />
              <small className="amount-note">
                {isCustomizedPlan 
                  ? "You can edit the amount (₹1 - ₹2,00,000)" 
                  : "Amount is fixed based on your selected plan"
                }
              </small>
            </div>
  
            {error && (
              <div className="error-message">
                <FaTimes className="error-icon" />
                <div>
                  <strong>Error:</strong>
                  <p>{error}</p>
                </div>
              </div>
            )}
  
            {success && (
              <div className="success-message">
                <FaCheckCircle className="success-icon" />
                <div>
                  <strong>Success!</strong>
                  <p>Redirecting to payment page...</p>
                </div>
              </div>
            )}
  
            <div className="button-group">
              <button className="pay-button" onClick={handlePayment} disabled={isPaymentDisabled()}>
                {loading ? <><FaSpinner className="spinner" />Processing...</> : <><FaCreditCard />Pay Now</>}
              </button>
            </div>
          </div>
  
        </div>
      </div>
    );
}

export default Paynow